import { Injectable } from '@angular/core';
import localforage from 'localforage';
import { IAsyncStorage } from '@pwaPortal/core/interfaces/IAsyncStorage';

@Injectable({
  providedIn: 'root',
})
export class AsyncStorage implements IAsyncStorage {
  constructor() {
    localforage.config({
      name: 'PWA_DB',
      version: 1.0,
    });
  }

  async ready(): Promise<void> {
    return localforage.ready();
  }

  get(key: string): Promise<any | null> {
    return localforage.getItem(key);
  }

  set(key: any, value: any): Promise<void> {
    return localforage.setItem(key, value);
  }

  async has(key: string): Promise<boolean> {
    const candidate: string | null = await this.get(key);
    return candidate !== null;
  }

  remove(key: string): Promise<void> {
    return localforage.removeItem(key);
  }

  listKeys(): Promise<string[]> {
    return localforage.keys();
  }

  DELETE_ALL(): Promise<void> {
    return localforage.clear();
  }
}
